module.exports = __webpack_public_path__ + "img/hm_signage.1732c3de.png";